import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export function swiper3() {

  const swiper3 = new Swiper('.swiper-container-3', {

    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 30,

    // paginacion
    pagination: {
      el: ".swiper-pagination",
    },
  });
}
